import { FileSearch } from "lucide-react";
import type { AronSource } from "../types";
import { entityLink } from "../utils/entityRoute";
import { AronRefLink } from "./AronRefLink";

function routeFor(s: AronSource): string | null {
  return entityLink(s.entity_type, s.entity_id)?.route ?? null;
}

// Deterministic citations: built from the audited api_call objects (AronToolCall),
// not from anything the model claimed — so a source always points at data ARON
// actually retrieved.
export function AronSources({
  sources,
  conversationId,
}: {
  sources: AronSource[];
  conversationId?: string | null;
}) {
  if (!sources.length) return null;
  // Dedupe by entity_type + id.
  const seen = new Set<string>();
  const unique = sources.filter((s) => {
    const k = `${s.entity_type}:${s.entity_id}`;
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });

  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5 border-t border-gray-100 pt-2 dark:border-gray-700">
      <span className="inline-flex items-center gap-1 text-[11px] uppercase tracking-wide text-gray-400">
        <FileSearch size={11} /> Źródła
      </span>
      {unique.map((s) => {
        const to = routeFor(s);
        const label = `${s.entity_type} ${s.entity_id.slice(0, 8)}`;
        const cls =
          "rounded bg-gray-100 px-1.5 py-0.5 text-[11px] text-gray-600 dark:bg-gray-700 dark:text-gray-300";
        return to ? (
          <AronRefLink key={`${s.entity_type}:${s.entity_id}`} to={to} conversationId={conversationId} className={cls}>
            {label}
          </AronRefLink>
        ) : (
          <span key={`${s.entity_type}:${s.entity_id}:${s.path}`} className={cls} title={s.path}>
            {label}
          </span>
        );
      })}
    </div>
  );
}
